import { array, arrayOf, bool, number, object, objectOf, string, func, instanceOf, element } from 'prop-types';

export const PersonalizedSectionPropTypes = {
    sectionName: string.isRequired,
    personalizedContent: object.isRequired,
    sliderBreakpoints: array,
    sliderBaseNum: number,
    isLoading: bool,
    isLazy: bool,
    displayISpeak: bool,
    className: string,
    mixpanelMetadata: object,
    showTranslatedUGC: bool,
    recentlyViewedChoiceGigs: arrayOf(number),
    choiceAlgos: objectOf(arrayOf(string)),
    onError: func,
    collectProps: object,
    container: instanceOf(element),
    appName: string,
    perseusName: string,
    headerTitleClass: string,
    features: object,
    onImpression: func,
    fallback: instanceOf(element),
    placeholder: instanceOf(element),
    biParams: object,
    extraParams: object,
    rollouts: object,
    complianceData: object,
};

export const PersonalizedSectionCommonPropTypes = {
    ...PersonalizedSectionPropTypes,
    PersonalizedComponentMapper: instanceOf(element),
};
